import { v4 } from 'uuid';

export const newUuid = () => v4();
